export default __webpack_public_path__ + "static/media/Heading-02.9663ea51.jpg";